import { useQuery } from '@tanstack/react-query';
import { changeHistoryViewerApi } from '../api/changeHistoryViewerApi';

/**
 * GET /change-history-viewer/diff?entityId=...&from=...&to=...
 * queryKey: ['change-history-viewer', 'diff', entityId, from, to]
 *
 * 모든 파라미터가 지정된 경우에만 활성화
 */
export function useRevisionDiff(
  entityId: number | undefined,
  from: number | undefined,
  to: number | undefined
) {
  return useQuery({
    queryKey: ['change-history-viewer', 'diff', entityId, from, to] as const,
    queryFn: () =>
      changeHistoryViewerApi.getDiff({
        entityId: entityId!,
        from: from!,
        to: to!,
      }),
    enabled: entityId !== undefined && from !== undefined && to !== undefined && from < to,
    staleTime: 60_000,
    retry: false, // diff 실패는 재시도 안 함 (HISTORY-404-001 / CHGHIST-422-001)
  });
}
